import { render } from "./CreateAssetForm.vue?vue&type=template&id=41c89d95"
import script from "./CreateAssetForm.vue?vue&type=script&lang=js"
export * from "./CreateAssetForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__